import {
    Button,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalNext,
    ToastProvider,
} from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import {
    StatusComponent,
    SubmissionIntakeUtil,
    useWniModal,
} from 'wni-components-platform-react';
import metadata from './ImportToSpreadSheetIntakeModal.metadata.json5';
import messages from './ImportToSpreadSheetInTake.messages'

function ImportToSpreadSheetIntakeModal(props) {
    const modalApi = useWniModal();
    const {
        size,
        cancelBtnLabel,
        isOpen,
        onReject,
        title,
        useDependenciesData,
        useAuthenticationData,
        extendProps: { jobID, sessionUUID },
        importToSpreadSheetFunc,
        page,
    } = props;
    const {
        loadingMask: { setLoadingMask },
    } = useDependenciesData;
    const {
        authHeader
    } = useAuthenticationData
    const [file, updateFile] = useState(null);
    const [spreadSheetReviewUrl, updateSpreadSheetReviewUrl] = useState();

    const getDocUploadToken = useCallback(async () => {
        try {
            const uploadTokenID =
                await GatewayDocumentService.generateUploadToken(authHeader);
            return uploadTokenID;
        } catch (e) {
            return modalApi
                .showAlert({
                    title: commonMessages.errorUploadTitle,
                    message: commonMessages.errorGenerateUploadToken,
                    status: 'error',
                    icon: 'gw-error-outline',
                    confirmButtonText: commonMessages.ok,
                })
                .catch(_.noop);
        }
    }, [authHeader, modalApi]);

    
    const callbackMap = {
        spreadsheetImportedCallback: {
            call: async (submissionNumber) => {
                ToastProvider.toast({
                    autoClose: 5000,
                    autoFocus: false,
                    message: `Spreadsheet Imported: ${submissionNumber}`,
                    type: 'success',
                });
            },
            needModalOnReject: true,
        },
        closeSpreadsheetCallback: {
            call: async () => {
                // do nothing
            },
            needModalOnReject: true,
        }
    };

    const modalCallbackMap = SubmissionIntakeUtil.generateModalCallbackMap(
        callbackMap,
        onReject
    );

    const uploadfile = (newfile) => {
        updateFile(newfile);
    };
    const handleImport = async () => {
        if (!file) {
            return false;
        }
        setLoadingMask(true);
        const documentMetaDataTemplate = {
            jobNumber: jobID,
            docUID: '001',
            documentType: 'Exc_Ext',
            status: 'approved',
            name: file.name,
            mimeType: file.type,
            sessionID: await getDocUploadToken(),
            sessionUUID: sessionUUID,
            page: page,
        };
        const reviewUrl = await importToSpreadSheetFunc(
            file,
            documentMetaDataTemplate,
            authHeader
        );

        updateSpreadSheetReviewUrl(reviewUrl);
        setLoadingMask(false);
    };

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: 'left',
            showRequired: true,
        },
        uploadDoc: {
            singleUpload: true,
            uploadConfig: {
                uploadFiles: file,
                updateUploadFiles: updateFile,
                required: true
            }
        }
    };
    const resolvers = {
        resolveCallbackMap: {
            uploadfile,
        },
        resolveComponentMap: {},
    };

    if (spreadSheetReviewUrl) {
        const { deploymentId } = SubmissionIntakeUtil.getConfigs();
        return (
            <ModalNext isOpen={isOpen} className="full modalHeaderWithBorder">
                <ModalBody id="importVehicleMFE">
                    <StatusComponent
                        {...props}
                        acrodReviewUrl={spreadSheetReviewUrl}
                        submissionTokenId={spreadSheetReviewUrl.substring(
                            spreadSheetReviewUrl.indexOf('submissionID') + 13
                        )}
                        urlPrefix="/spreadsheet-review"
                        deploymentId={deploymentId}
                        requireManualStatusCheck
                        authdata={useAuthenticationData}
                        pcSubmittedCallback={() => onReject()}
                        callbackMap={modalCallbackMap}
                    />
                </ModalBody>
                <ModalFooter
                    contentLayout={{
                        component: 'flex',
                        componentProps: {
                            alignItems: 'middle',
                            justifyContent: 'between',
                        },
                    }}
                >
                    <Button
                        onClick={onReject}
                        type="outlined"
                        label={messages.close}
                    />
                </ModalFooter>
            </ModalNext>
        );
    }

    return (
        <ModalNext isOpen={isOpen} className={`${size} modalHeaderWithBorder`}>
            <ModalHeader title={title} />
            <ModalBody id="importVehicle">
                <ViewModelForm
                    uiProps={metadata.componentContent}
                    overrideProps={overrideProps}
                    model={{}}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </ModalBody>
            <ModalFooter
                contentLayout={{
                    component: 'flex',
                    componentProps: {
                        alignItems: 'middle',
                        justifyContent: 'between',
                    },
                }}
            >
                <Button
                    onClick={onReject}
                    type="outlined"
                    label={cancelBtnLabel}
                />
                <Button
                    onClick={handleImport}
                    disabled={!file}
                    label="Import"
                />
            </ModalFooter>
        </ModalNext>
    );
}

ImportToSpreadSheetIntakeModal.propTypes = {};
ImportToSpreadSheetIntakeModal.defaultProps = {
    size: 'md',
    title: ''
};
export default ImportToSpreadSheetIntakeModal;
